import { render, staticRenderFns } from "./VeniRL.vue?vue&type=template&id=2d464fa9"
import script from "./VeniRL.vue?vue&type=script&lang=js"
export * from "./VeniRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports